
import { VueModule } from '@Foundation/utilities';
import ChannelAdvisorCtaButton from './code/Script/components/channel-advisor-cta-button.vue';
import ChannelAdvisorModal from './code/Script/components/channel-advisor-modal.vue';

export default VueModule({
  components: {
    ChannelAdvisorCtaButton,
    ChannelAdvisorModal
  }
});
